(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8241,9207,6530],{

/***/ 2510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes",
      function () {
        return __webpack_require__(99264);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50937);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71415);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 49610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HorizontalLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);

function HorizontalLine(param) {
    let { height ="1px" , width ="100%" , color ="var(--white)" , margin ="0"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            height,
            width,
            backgroundColor: color,
            margin
        }
    });
}


/***/ }),

/***/ 23244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ profileDropdownLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58752);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86712);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29915);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11042);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30329);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75958);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90643);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93292);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__);









const profileDropdownLinks = [
    {
        label: "shops",
        href: "/shop",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "order.history",
        href: "/orders",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "refund.orders",
        href: "/orders/refunds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "liked.shops",
        href: "/liked/shops",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "liked.products",
        href: "/liked/products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "viewed.products",
        href: "/product/viewed",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "profile.settings",
        href: "/profile",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "site.settings",
        href: "/settings",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
            size: 24
        }),
        requiredAuth: false
    }
];


/***/ }),

/***/ 12651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34741);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30300);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85286);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 26287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SettingsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99207);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54340);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_settings_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18438);





function SettingsContainer(param) {
    let { children  } = param;
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
            children: [
                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sidebar),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                withLinks: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().line)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().body),
                    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child)=>child ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child) : null)
                })
            ]
        })
    });
}


/***/ }),

/***/ 99207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67824);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36291);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82807);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38114);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14606);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36594);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90910);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84686);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_scrollToView__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28099);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92879);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49369);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13644);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59108);
/* harmony import */ var components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23244);















function Sidebar(param) {
    let { data , withLinks =false , onClose  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { query , pathname  } = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    const { logout , isAuthenticated , openAuthModal  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const links = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(()=>{
        if (isAuthenticated) {
            return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__/* .profileDropdownLinks.filter */ .a.filter((item)=>item.href !== "/shop");
        }
        return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__/* .profileDropdownLinks.filter */ .a.filter((item)=>!item.requiredAuth && item.href !== "/shop");
    }, [
        isAuthenticated
    ]);
    const handleLogout = ()=>{
        logout();
    };
    const handleClose = ()=>{
        if (onClose) {
            onClose();
        }
    };
    const renderAuthButton = ()=>{
        if (!isAuthenticated) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
                onClick: ()=>openAuthModal(),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10___default()), {
                                size: 24
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("login")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                        size: 20
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: "button",
            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
            onClick: handleLogout,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                            size: 24
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("log.out")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                    size: 20
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/shop",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname === "/shop" && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("shops")
                                })
                            ]
                        })
                    }),
                    !withLinks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: {
                            pathname: "/liked/products",
                            query: {
                                shop_id: query === null || query === void 0 ? void 0 : query.id
                            }
                        },
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname.includes("/liked/products") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("liked.products")
                                })
                            ]
                        })
                    }),
                    withLinks && links.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: item.href,
                            className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname === item.href && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t(item.label)
                                    })
                                ]
                            })
                        }, item.href))
                ]
            }),
            !!(data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryContainer),
                children: data === null || data === void 0 ? void 0 : data.map((category)=>{
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: ()=>{
                            return (0,utils_scrollToView__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(category === null || category === void 0 ? void 0 : category.uuid, -70);
                        },
                        type: "button",
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().category),
                        children: category === null || category === void 0 ? void 0 : (ref = category.translation) === null || ref === void 0 ? void 0 : ref.title
                    }, category === null || category === void 0 ? void 0 : category.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/help",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname.includes("/help") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t("help.center")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                                size: 20
                            })
                        ]
                    }),
                    renderAuthButton()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59108);

function useModal() {
    let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen);
    const handleOpen = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(true);
    };
    const handleClose = ()=>setOpen(false);
    return [
        open,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 82986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePopover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59108);

function usePopover() {
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event)=>{
        return setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    };
    const handleClose = ()=>setAnchorEl(null);
    return [
        open,
        anchorEl,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 99264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Recipes; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(12651);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(65564);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./containers/recipeListHeader/recipeListHeader.module.scss
var recipeListHeader_module = __webpack_require__(65457);
var recipeListHeader_module_default = /*#__PURE__*/__webpack_require__.n(recipeListHeader_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(82807);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(18438);
// EXTERNAL MODULE: ./containers/recipeNavbar/recipeNavbar.module.scss
var recipeNavbar_module = __webpack_require__(38333);
var recipeNavbar_module_default = /*#__PURE__*/__webpack_require__.n(recipeNavbar_module);
// EXTERNAL MODULE: ./hooks/usePopover.tsx
var usePopover = __webpack_require__(82986);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(36291);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(49369);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowDownSLineIcon.js
var ArrowDownSLineIcon = __webpack_require__(64402);
var ArrowDownSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowDownSLineIcon);
;// CONCATENATED MODULE: ./containers/recipeNavbar/recipeNavbar.tsx









const CategoryDropdown = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(7966), __webpack_require__.e(9468)]).then(__webpack_require__.bind(__webpack_require__, 33263)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33263)
            ]
    }
});
function RecipeNavbar(param) {
    let { categories  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const { query  } = (0,router.useRouter)();
    const categoryId = Number(query.category_id);
    const [openDropdown, anchorDropdown, handleOpenDropdown, handleCloseDropdown] = (0,usePopover/* default */.Z)();
    const { list , rest  } = (0,react.useMemo)(()=>{
        if (categories.length > 3) {
            return {
                list: categories.slice(0, 3),
                rest: categories.slice(3)
            };
        }
        return {
            list: categories,
            rest: []
        };
    }, [
        categories
    ]);
    function filterByCategory(event) {
        let id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        event.preventDefault();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (recipeNavbar_module_default()).navbar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (recipeNavbar_module_default()).navItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/recipes",
                    shallow: true,
                    replace: true,
                    className: "".concat((recipeNavbar_module_default()).navLink, " ").concat(categoryId ? "" : (recipeNavbar_module_default()).active),
                    children: t("all")
                })
            }),
            list.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (recipeNavbar_module_default()).navItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/recipes?category_id=".concat(item.id),
                        shallow: true,
                        replace: true,
                        className: "".concat((recipeNavbar_module_default()).navLink, " ").concat(item.id === categoryId ? (recipeNavbar_module_default()).active : ""),
                        children: item.translation.title
                    })
                }, item.id)),
            rest.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (recipeNavbar_module_default()).navItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (recipeNavbar_module_default()).moreBtn,
                    onClick: handleOpenDropdown,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (recipeNavbar_module_default()).text,
                            children: t("more")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowDownSLineIcon_default()), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryDropdown, {
                data: rest,
                handleClickItem: filterByCategory,
                open: openDropdown,
                anchorEl: anchorDropdown,
                onClose: handleCloseDropdown
            })
        ]
    });
}

// EXTERNAL MODULE: ./containers/mobileRecipeNavbar/mobileRecipeNavbar.module.scss
var mobileRecipeNavbar_module = __webpack_require__(55644);
var mobileRecipeNavbar_module_default = /*#__PURE__*/__webpack_require__.n(mobileRecipeNavbar_module);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(1543);
;// CONCATENATED MODULE: ./containers/mobileRecipeNavbar/mobileRecipeNavbar.tsx









const MobileDrawer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(8577), __webpack_require__.e(8329), __webpack_require__.e(1040)]).then(__webpack_require__.bind(__webpack_require__, 79002)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79002)
            ]
    }
});
function MobileRecipeNavbar(param) {
    let { categories =[]  } = param;
    var ref, ref1;
    const { t  } = (0,es/* useTranslation */.$G)();
    const { query  } = (0,router.useRouter)();
    const categoryId = Number(query.category_id);
    const [visible, handleOpenCategories, handleCloseCategories] = (0,useModal/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (mobileRecipeNavbar_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mobileRecipeNavbar_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (mobileRecipeNavbar_module_default()).showAllBtn,
                    onClick: handleOpenCategories,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (mobileRecipeNavbar_module_default()).text,
                            children: categoryId ? (ref = categories.find((item)=>item.id === categoryId)) === null || ref === void 0 ? void 0 : (ref1 = ref.translation) === null || ref1 === void 0 ? void 0 : ref1.title : t("all")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowDownSLineIcon_default()), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDrawer, {
                open: visible,
                onClose: handleCloseCategories,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobileRecipeNavbar_module_default()).drawerWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/recipes",
                            shallow: true,
                            replace: true,
                            className: "".concat((mobileRecipeNavbar_module_default()).item, " ").concat(categoryId ? "" : (mobileRecipeNavbar_module_default()).active),
                            onClick: handleCloseCategories,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (mobileRecipeNavbar_module_default()).text,
                                children: t("all")
                            })
                        }),
                        categories.map((item)=>{
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                href: "/recipes?category_id=".concat(item.id),
                                shallow: true,
                                replace: true,
                                className: "".concat((mobileRecipeNavbar_module_default()).item, " ").concat(item.id === categoryId ? (mobileRecipeNavbar_module_default()).active : ""),
                                onClick: handleCloseCategories,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (mobileRecipeNavbar_module_default()).text,
                                    children: (ref = item.translation) === null || ref === void 0 ? void 0 : ref.title
                                })
                            }, item.id);
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./containers/recipeListHeader/recipeListHeader.tsx







function RecipeListHeader(param) {
    let { categories =[]  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1140px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (recipeListHeader_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (recipeListHeader_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (recipeListHeader_module_default()).title,
                        children: t("recipes.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (recipeListHeader_module_default()).text,
                        children: t("recipes.description")
                    })
                ]
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipeNavbar, {
                categories: categories
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileRecipeNavbar, {
                categories: categories
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(65084);
// EXTERNAL MODULE: ./services/category.ts
var category = __webpack_require__(60815);
// EXTERNAL MODULE: ./services/recipe.ts
var recipe = __webpack_require__(73884);
// EXTERNAL MODULE: ./containers/recipeList/recipeList.module.scss
var recipeList_module = __webpack_require__(57806);
var recipeList_module_default = /*#__PURE__*/__webpack_require__.n(recipeList_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(74647);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(57238);
// EXTERNAL MODULE: ./components/recipeCard/recipeCard.module.scss
var recipeCard_module = __webpack_require__(73137);
var recipeCard_module_default = /*#__PURE__*/__webpack_require__.n(recipeCard_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(19276);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(80869);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/TimeFillIcon.js
var TimeFillIcon = __webpack_require__(17905);
var TimeFillIcon_default = /*#__PURE__*/__webpack_require__.n(TimeFillIcon);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/RestaurantFillIcon.js
var RestaurantFillIcon = __webpack_require__(5930);
var RestaurantFillIcon_default = /*#__PURE__*/__webpack_require__.n(RestaurantFillIcon);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(62475);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(2201);
// EXTERNAL MODULE: ./components/line/horizontalLine.tsx
var horizontalLine = __webpack_require__(49610);
;// CONCATENATED MODULE: ./components/recipeCard/recipeCard.tsx












function RecipeCard(param) {
    let { data  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { t  } = (0,es/* useTranslation */.$G)();
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/recipes/".concat(data === null || data === void 0 ? void 0 : data.id, "?currency_id=").concat(currency === null || currency === void 0 ? void 0 : currency.id),
        className: (recipeCard_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (recipeCard_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data === null || data === void 0 ? void 0 : data.img),
                    alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    sizes: "400px",
                    priority: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (recipeCard_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (recipeCard_module_default()).main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (recipeCard_module_default()).title,
                                children: (data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title) || t("N/A")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontalLine/* default */.Z, {
                                color: "var(--border-color)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (recipeCard_module_default()).text,
                                children: (data === null || data === void 0 ? void 0 : (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.description) || t("N/A")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontalLine/* default */.Z, {
                        color: "var(--border-color)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (recipeCard_module_default()).footer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (recipeCard_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((TimeFillIcon_default()), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (recipeCard_module_default()).text,
                                        children: [
                                            data === null || data === void 0 ? void 0 : data.total_time,
                                            " ",
                                            t("min")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (recipeCard_module_default()).dot
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (recipeCard_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((RestaurantFillIcon_default()), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (recipeCard_module_default()).text,
                                        children: [
                                            data === null || data === void 0 ? void 0 : data.calories,
                                            " ",
                                            t("kkl")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (recipeCard_module_default()).shopIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                            src: data === null || data === void 0 ? void 0 : (ref3 = data.shop) === null || ref3 === void 0 ? void 0 : ref3.logo_img,
                            alt: data === null || data === void 0 ? void 0 : (ref4 = data.shop) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.translation) === null || ref5 === void 0 ? void 0 : ref5.title,
                            fill: true,
                            sizes: "100px"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./containers/recipeList/recipeList.tsx





function RecipeList(param) {
    let { data , loading  } = param;
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1140px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        style: {
            display: !loading && data.length === 0 ? "none" : "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (recipeList_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: isDesktop ? 4 : 2,
                children: !loading ? data.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        lg: 4,
                        xl: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipeCard, {
                            data: item
                        })
                    }, item.id)) : Array.from(new Array(5)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        lg: 2.4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            className: (recipeList_module_default()).shimmer
                        })
                    }, "recipe" + idx))
            })
        })
    });
}

// EXTERNAL MODULE: ./containers/settings/settings.tsx
var settings = __webpack_require__(26287);
;// CONCATENATED MODULE: ./pages/recipes/index.tsx












const Empty = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1630).then(__webpack_require__.bind(__webpack_require__, 21630)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21630)
            ]
    }
});
const Loader = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1134).then(__webpack_require__.bind(__webpack_require__, 31134)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31134)
            ]
    }
});
function Recipes(param) {
    let {} = param;
    var ref;
    const { i18n , t  } = (0,es/* useTranslation */.$G)();
    const locale = i18n.language;
    const { query  } = (0,router.useRouter)();
    const categoryId = Number(query.category_id);
    const shopId = Number(query.shop_id);
    const loader = (0,react.useRef)(null);
    const { data: categories  } = (0,react_query_es.useQuery)([
        "recipeCategories",
        locale
    ], ()=>category/* default.getAllRecipeCategories */.Z.getAllRecipeCategories({
            perPage: 100
        }));
    const { data , fetchNextPage , hasNextPage , isFetchingNextPage , isLoading  } = (0,react_query_es.useInfiniteQuery)([
        "recipes",
        categoryId,
        shopId,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return recipe/* default.getAll */.Z.getAll({
            page: pageParam,
            perPage: 12,
            category_id: categoryId || undefined,
            shop_id: shopId || undefined
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        }
    });
    const recipes = (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [];
    const handleObserver = (0,react.useCallback)((entries)=>{
        const target = entries[0];
        if (target.isIntersecting && hasNextPage) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        hasNextPage
    ]);
    (0,react.useEffect)(()=>{
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current);
    }, [
        handleObserver,
        hasNextPage,
        fetchNextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: t("recipes.title"),
                description: t("recipes.description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(settings/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipeListHeader, {
                        categories: categories === null || categories === void 0 ? void 0 : categories.data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipeList, {
                        data: recipes,
                        loading: isLoading && !isFetchingNextPage
                    }),
                    isFetchingNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: loader
                    }),
                    !recipes.length && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {
                        text: t("no.recipes")
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 60815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const categoryService = {
    getAllShopCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "shop"
            }
        });
    },
    getAllSubCategories: function(categoryId) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/categories/sub-shop/".concat(categoryId), {
            params
        });
    },
    getAllProductCategories: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/categories"), {
            params
        }),
    getAllRecipeCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "receipt"
            }
        });
    },
    getById: function(id) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/".concat(id), {
            params
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (categoryService);


/***/ }),

/***/ 73884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const recipeService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (recipeService);


/***/ }),

/***/ 19276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 28099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollToView; }
/* harmony export */ });
function scrollToView(uuid) {
    let yOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!uuid) {
        return;
    }
    const element = document.getElementById(uuid);
    if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    } else {
        var ref, ref1;
        window.location.hash = uuid;
        const element1 = document.getElementById("the-end");
        const y1 = (element1 === null || element1 === void 0 ? void 0 : (ref = element1.getBoundingClientRect) === null || ref === void 0 ? void 0 : (ref1 = ref.call(element1)) === null || ref1 === void 0 ? void 0 : ref1.top) + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y1,
            behavior: "smooth"
        });
    }
}


/***/ }),

/***/ 50937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 73137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recipeCard_wrapper__0idu5","header":"recipeCard_header__DFJS8","body":"recipeCard_body__Dy5ek","main":"recipeCard_main__hzXPg","title":"recipeCard_title__R8fph","text":"recipeCard_text__XHWLK","footer":"recipeCard_footer__ykPOn","item":"recipeCard_item__GmQzg","dot":"recipeCard_dot__6bxIP","shopIcon":"recipeCard_shopIcon__wfFlp"};

/***/ }),

/***/ 55644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"mobileRecipeNavbar_container__y02mn","wrapper":"mobileRecipeNavbar_wrapper__0qXae","showAllBtn":"mobileRecipeNavbar_showAllBtn__qCUAa","text":"mobileRecipeNavbar_text__xRXGX","drawerWrapper":"mobileRecipeNavbar_drawerWrapper__Rc2T5","item":"mobileRecipeNavbar_item__Rv05p","active":"mobileRecipeNavbar_active__9OmaR"};

/***/ }),

/***/ 57806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"recipeList_container__sh7Zp","header":"recipeList_header__dIYOR","title":"recipeList_title__zyECz","shimmer":"recipeList_shimmer__3QP_8"};

/***/ }),

/***/ 65457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"recipeListHeader_container__ZEaso","header":"recipeListHeader_header__o_F8n","title":"recipeListHeader_title__KWbw2","text":"recipeListHeader_text___3P6c"};

/***/ }),

/***/ 38333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navbar":"recipeNavbar_navbar__2Rplt","navItem":"recipeNavbar_navItem__lK99u","moreBtn":"recipeNavbar_moreBtn__9Beuj","text":"recipeNavbar_text__30pjj","navLink":"recipeNavbar_navLink__xYiv1","active":"recipeNavbar_active__2CWs_"};

/***/ }),

/***/ 54340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__rObHi","sidebar":"settings_sidebar____hs3","line":"settings_line__zzjer","body":"settings_body__uMN7T"};

/***/ }),

/***/ 67824:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar_container__IjaDC","links":"sidebar_links__LM_pw","link":"sidebar_link__6YsEF","body":"sidebar_body__cwbZC","active":"sidebar_active__rrguH","categoryContainer":"sidebar_categoryContainer__3wSEp","category":"sidebar_category__b_8_c"};

/***/ }),

/***/ 51834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(58761)


/***/ }),

/***/ 64402:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowDownSLineIcon = function ArrowDownSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z' })
  );
};

var ArrowDownSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowDownSLineIcon) : ArrowDownSLineIcon;

module.exports = ArrowDownSLineIcon$1;


/***/ }),

/***/ 90910:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 5930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var RestaurantFillIcon = function RestaurantFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M21 2v20h-2v-8h-3V7a5 5 0 0 1 5-5zM9 13.9V22H7v-8.1A5.002 5.002 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5.002 5.002 0 0 1-4 4.9z' })
  );
};

var RestaurantFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(RestaurantFillIcon) : RestaurantFillIcon;

module.exports = RestaurantFillIcon$1;


/***/ }),

/***/ 17905:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var TimeFillIcon = function TimeFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-10V7h-2v7h6v-2h-4z' })
  );
};

var TimeFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(TimeFillIcon) : TimeFillIcon;

module.exports = TimeFillIcon$1;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7238,5889,9774,2888,179], function() { return __webpack_exec__(2510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);